export const environment = {
  production: true,
  server: 'http://167.99.229.209/api'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts